import { createStore, applyMiddleware} from 'redux';
import {persistStore, autoRehydrate} from 'redux-persist'
import rootReducer from '../reducers';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {REHYDRATE_DONE, REHYDRATE_START, REHYDRATE_TRIGGER_WAITING} from '../actions/rehydrate'

let autoRehydrateWaiting = [];

const autoRehydrateWait = store => next => action => {
  const state = store.getState();
  // dispatch waiting action when REHYDRATE completes
  if (action.type === REHYDRATE_TRIGGER_WAITING) {
    store.dispatch({
      type:  REHYDRATE_DONE,
      value: true
    });
    autoRehydrateWaiting.forEach(action => {
      store.dispatch(action);
    });
    autoRehydrateWaiting = [];
  }
  // if we didn't rehydrate save action and wait for when REHYDRATE completes
  if (state.rehydrate.value === false && action.type !== REHYDRATE_START && action.type !== REHYDRATE_DONE) {
    autoRehydrateWaiting.push(action);
  } else {
    // everything is ok continue with action
    return next(action);
  }
};

export default function configureStore() {
  const store = createStore(
    rootReducer,
    applyMiddleware(thunk, autoRehydrateWait, createLogger()),
    autoRehydrate({log:true})
  );

  persistStore(store,  {blacklist: ['rehydrate']}, () => {
    store.dispatch({
        type:  REHYDRATE_TRIGGER_WAITING
      });
  });
  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js